module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user.company) ? [_c('router-view', {
    attrs: {
      "name": "menu"
    },
    on: {
      "toggle-drawer": _vm.toggleDrawer
    }
  }), _vm._v(" "), _c('partial-drawer-navigation', {
    class: {
      'sidenav-open': _vm.showDrawer
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('vue-snotify')], 1), _vm._v(" "), _c('CoockiesModal'), _vm._v(" "), _c('partial-footer')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cac28ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 955
// module chunks = 34